import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'footer.socialLinks.srText.facebook': {
    id: 'footer.socialLinks.srText.facebook',
    defaultMessage: 'Like edX on Facebook',
    description: 'This is screenreader text for the edX Facebook social media link in the footer.',
  },
  'footer.socialLinks.srText.twitter': {
    id: 'footer.socialLinks.srText.twitter',
    defaultMessage: 'Follow edX on Twitter',
    description: 'This is screenreader text for the edX Twitter social media link in the footer.',
  },
  'footer.socialLinks.srText.youtube': {
    id: 'footer.socialLinks.srText.youtube',
    defaultMessage: 'Subscribe to the edX YouTube channel',
    description: 'This is screenreader text for the edX YouTube social media link in the footer.',
  },
  'footer.socialLinks.srText.linkedin': {
    id: 'footer.socialLinks.srText.linkedin',
    defaultMessage: 'Follow edX on LinkedIn',
    description: 'This is screenreader text for the edX LinkedIn social media link in the footer.',
  },
  'footer.socialLinks.srText.reddit': {
    id: 'footer.socialLinks.srText.reddit',
    defaultMessage: 'Subscribe to the edX subreddit',
    description: 'This is screenreader text for the edX reddit social media link in the footer.',
  },
  'footer.languageForm.select.label': {
    id: 'footer.languageForm.select.label',
    defaultMessage: 'Choose Language',
    description: 'The label for the laguage select part of the language selection form.',
  },
  'footer.languageForm.submit.label': {
    id: 'footer.languageForm.submit.label',
    defaultMessage: 'Apply',
    description: 'The label for button to submit the language selection form.',
  },
  'footer.edxLinks.about': {
    id: 'footer.edxLinks.about',
    defaultMessage: 'About',
    description: 'The label for the link to the about edX page.',
  },
  'footer.edxLinks.business': {
    id: 'footer.edxLinks.business',
    defaultMessage: 'edX for Business',
    description: 'The label for the link to the edX for business page.',
  },
  'footer.edxLinks.affiliates': {
    id: 'footer.edxLinks.affiliates',
    defaultMessage: 'Affiliates',
    description: 'The label for the link to the edX affiliates page.',
  },
  'footer.edxLinks.openEdx': {
    id: 'footer.edxLinks.openEdx',
    defaultMessage: 'Open edX',
    description: 'The label for the link to the open edX site.',
  },
  'footer.edxLinks.careers': {
    id: 'footer.edxLinks.careers',
    defaultMessage: 'Careers',
    description: 'The label for the link to the edX Careers page.',
  },
  'footer.edxLinks.news': {
    id: 'footer.edxLinks.news',
    defaultMessage: 'News',
    description: 'The label for the link to the edX news page.',
  },
  'footer.legalLinks.heading': {
    id: 'footer.legalLinks.heading',
    defaultMessage: 'Legal',
    description: 'Heading for the legal links section of the footer.',
  },
  'footer.legalLinks.termsOfService': {
    id: 'footer.legalLinks.termsOfService',
    defaultMessage: 'Terms of Service & Honor Code',
    description: 'The label for the link to the edX terms of service page.',
  },
  'footer.legalLinks.privacyPolicy': {
    id: 'footer.legalLinks.privacyPolicy',
    defaultMessage: 'Privacy Policy',
    description: 'The label for the link to the edX privacy policy page.',
  },
  'footer.legalLinks.a11yPolicy': {
    id: 'footer.legalLinks.a11yPolicy',
    defaultMessage: 'Accessibility Policy',
    description: 'The label for the link to the edX accessibility policy page.',
  },
  'footer.legalLinks.trademarkPolicy': {
    id: 'footer.legalLinks.trademarkPolicy',
    defaultMessage: 'Trademark Policy',
    description: 'The label for the link to the edX trademark policy page.',
  },
  'footer.legalLinks.sitemap': {
    id: 'footer.legalLinks.sitemap',
    defaultMessage: 'Sitemap',
    description: 'The label for the link to the edX sitemap page.',
  },
  'footer.connectLinks.heading': {
    id: 'footer.connectLinks.heading',
    defaultMessage: 'Connect',
    description: 'Heading for the connect links section of the footer.',
  },
  'footer.connectLinks.blog': {
    id: 'footer.connectLinks.blog',
    defaultMessage: 'Blog',
    description: 'The label for the link to the edX blog.',
  },
  'footer.connectLinks.contact': {
    id: 'footer.connectLinks.contact',
    defaultMessage: 'Contact Us',
    description: 'The label for the link to the contact edX page.',
  },
  'footer.connectLinks.help': {
    id: 'footer.connectLinks.help',
    defaultMessage: 'Help Center',
    description: 'The label for the link to the edX help center.',
  },
  'footer.connectLinks.mediaKit': {
    id: 'footer.connectLinks.mediaKit',
    defaultMessage: 'Media Kit',
    description: 'The label for the link to the edX media kit page.',
  },
  'footer.connectLinks.donate': {
    id: 'footer.connectLinks.donate',
    defaultMessage: 'Donate',
    description: 'The label for the link to the edX donation page.',
  },
  'footer.mobileApp.apple': {
    id: 'footer.mobileApp.apple',
    defaultMessage: 'Download the edX mobile app from the Apple App Store',
    description: 'The label for the link to download the apple version of the edX app.',
  },
  'footer.mobileApp.google': {
    id: 'footer.mobileApp.google',
    defaultMessage: 'Download the edX mobile app from Google Play',
    description: 'The label for the link to download the google version of the edX app.',
  },
  'footer.logo.altText': {
    id: 'footer.logo.altText',
    defaultMessage: 'Powered by Open edX',
    description: 'alt text for the footer logo.',
  },
  'footer.logo.ariaLabel': {
    id: 'footer.logo.ariaLabel',
    defaultMessage: 'edX Home',
    description: 'aria-label for the footer logo.',
  },
  'footer.ariaLabel': {
    id: 'footer.ariaLabel',
    defaultMessage: 'Page Footer',
    description: 'aria-label for the footer component',
  },
  'footer.links.coursesCatalog': {
    id: 'footer.links.coursesCatalog',
    defaultMessage: 'Courses catalog',
  },
  'footer.links.programsCatalog': {
    id: 'footer.links.programsCatalog',
    defaultMessage: 'Programs catalog',
  },
  'footer.links.educationDirections': {
    id: 'footer.links.educationDirections',
    defaultMessage: 'Education directions',
  },
  'footer.links.about': {
    id: 'footer.links.about',
    defaultMessage: 'About',
  },
  'footer.links.faq': {
    id: 'footer.links.faq',
    defaultMessage: 'FAQ',
  },
  'footer.links.feedback': {
    id: 'footer.links.feedback',
    defaultMessage: 'Ask a question',
  },
  'footer.links.requirements': {
    id: 'footer.links.requirements',
    defaultMessage: 'System requirements',
  },
  'footer.links.terms': {
    id: 'footer.links.terms',
    defaultMessage: 'User agreement',
  },
  'footer.links.contacts': {
    id: 'footer.links.contacts',
    defaultMessage: 'Contact information',
  },
  'footer.links.forMedia': {
    id: 'footer.links.forMedia',
    defaultMessage: 'Press',
  },
  'footer.links.policy': {
    id: 'footer.links.policy',
    defaultMessage: 'Personal data policy',
  },
  'footer.labels.copyright': {
    id: 'footer.labels.copyright',
    defaultMessage: 'Open Education',
  },
  'footer.news.messages.confirmation': {
    id: 'footer.news.messages.confirmation',
    defaultMessage: 'An email has been sent to you to confirm receipt of the newsletters.',
  },
  'footer.news.messages.subscription': {
    id: 'footer.news.messages.subscription',
    defaultMessage: 'Subscription activated.',
  },
  'footer.news.messages.activation': {
    id: 'footer.news.messages.activation',
    defaultMessage: 'The activation email was sent on {sentDate} at {sentTime}. The next email can be requested on {newDate} at {newTime}.',
  },
  'footer.news.messages.emailError': {
    id: 'footer.news.messages.emailError',
    defaultMessage: 'Error sending activation email.',
  },
  'footer.news.messages.error': {
    id: 'footer.news.messages.error',
    defaultMessage: 'Something went wrong.',
  },
  'footer.news.labels.subscribeLine1': {
    id: 'footer.news.labels.subscribeLine1',
    defaultMessage: 'Subscribe to news from',
  },
  'footer.news.labels.subscribeLine2': {
    id: 'footer.news.labels.subscribeLine2',
    defaultMessage: 'Open Education Russia',
  },
  'footer.news.labels.subscribe': {
    id: 'footer.news.labels.subscribe',
    defaultMessage: 'Subscribe',
  },
  'footer.news.labels.placeholder': {
    id: 'footer.news.labels.placeholder',
    defaultMessage: 'Enter your e-mail',
  },
});

export default messages;
